import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
// 申请信息各区块共用的文件与人员处理函数
export var IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'];
export var TASK_ITEM_KEY = {
  1: 'mall_decoration',
  2: 'bidding_support',
  3: 'card_and_coupon_design',
  9: 'quotation'
};
export var getProjectInfoStatus = function getProjectInfoStatus(projectStatus, formData) {
  return Number(projectStatus || formData.status);
};
export var findCustomerName = function findCustomerName(companyList, customerId) {
  var company = (companyList || []).find(function (item) {
    return item.id === customerId;
  });
  return company ? company.company_name : '';
};
export var buildDisabledTaskPrefixes = function buildDisabledTaskPrefixes(isTaskFormDisabled) {
  return ['1', '2', '3', '9'].filter(function (taskType) {
    return isTaskFormDisabled(taskType);
  }).map(function (taskType) {
    return "items.".concat(TASK_ITEM_KEY[taskType], ".");
  });
};
var getFileExtension = function getFileExtension(item) {
  return (item.url || item.file_name || '').split('.').pop().toLowerCase();
};
export var isImageFile = function isImageFile(item) {
  return IMAGE_EXTENSIONS.includes(getFileExtension(item));
};
export var isPdfFile = function isPdfFile(item) {
  return getFileExtension(item) === 'pdf';
};
export var resolveOssUrl = function resolveOssUrl(vm, url) {
  return /^(https?:)?\/\//.test(url) ? url : vm.$ossurl + url;
};
var _openPdfFile = function openPdfFile(vm, item) {
  window.open(resolveOssUrl(vm, item.url), '_blank');
};
export { _openPdfFile as openPdfFile };
var _downProjectFile = function downProjectFile(vm, url, fileName) {
  vm.$message.success('文件处理中…');
  var fullUrl = resolveOssUrl(vm, url);
  var baseName = fileName || url.split('/').pop().split('?')[0];
  var ext = (url.split('?')[0].split('.').pop() || '').toLowerCase();
  var finalName = ext && !baseName.toLowerCase().endsWith('.' + ext) ? baseName + '.' + ext : baseName;
  fetch(fullUrl).then(function (res) {
    return res.blob();
  }).then(function (blob) {
    var objectUrl = window.URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = objectUrl;
    link.download = finalName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(objectUrl);
  }).catch(function () {
    window.open(fullUrl, '_blank');
  });
};
export { _downProjectFile as downProjectFile };
export var handlePersonChargeChange = function handlePersonChargeChange(person, options) {
  var selected = (options || []).find(function (item) {
    return String(item.id) === String(person.person_charge_id);
  });
  person.person_charge_name = selected ? selected.name : '';
};

// 文件预览/下载与负责人回填在各任务区块中以同名方法暴露，保持模板调用不变
export default {
  methods: {
    isImageFile: isImageFile,
    isPdfFile: isPdfFile,
    openPdfFile: function openPdfFile(item) {
      _openPdfFile(this, item);
    },
    downProjectFile: function downProjectFile(url, fileName) {
      _downProjectFile(this, url, fileName);
    },
    handlePersonChargeChange: handlePersonChargeChange
  }
};